import { toSlug } from "../utilities/string-utilities";

const slugify = (el, { expression }, { effect, evaluate }) => {

    if (el.localName !== 'a') {
        console.warn('The slugify directive should only be used on anchor tags.');
    }

    effect(() => {
        const result = evaluate(expression);
        el.href = toSlug(result);
    })

};

export { slugify };